/* The server-rendered state is authoritative for this theme control. It is not
   server-side checkout enforcement. No price/approval values come from tags. */
(() => {
  let revision = 0;
  let pending = false;
  let checking = false;
  let failed = false;
  const components = () => [...document.querySelectorAll('trade-checkout')];
  const lock = (message) => {
    for (const element of components()) {
      element.querySelector('button').disabled = true;
      if (message) element.querySelector('[role="status"]').textContent = message;
    }
  };
  const invalidate = () => {
    revision += 1;
    pending = true;
    checking = false;
    failed = false;
    lock('Updating your order total…');
  };
  async function refresh() {
    const element = components()[0];
    if (!element || pending) return false;
    const currentRevision = ++revision;
    checking = true;
    lock('Checking your order total…');
    try {
      const response = await fetch(element.dataset.stateUrl, { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to check cart');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = html.querySelector('trade-checkout');
      if (!state) throw new Error('Missing cart state');
      if (currentRevision !== revision) return false;
      const qualifies = state.dataset.qualifies === 'true';
      failed = false;
      for (const control of components()) {
        control.dataset.qualifies = String(qualifies);
        control.querySelector('[role="status"]').textContent = state.querySelector('[role="status"]').textContent;
        control.querySelector('button').disabled = !qualifies;
      }
      return qualifies;
    } catch (error) {
      if (currentRevision === revision) {
        failed = true;
        lock('We couldn’t verify your order total. Refresh the page before checking out.');
      }
      return false;
    } finally {
      if (currentRevision === revision) checking = false;
    }
  }
  customElements.define('trade-checkout', class extends HTMLElement {
    connectedCallback() {
      if (pending || checking || failed) this.querySelector('button').disabled = true;
    }
  });
  // Lock immediately, before the theme's debounced quantity request starts.
  document.addEventListener('input', (event) => {
    if (event.target.matches('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]')) invalidate();
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]')) invalidate();
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('cart-remove-button')) invalidate();
  }, true);
  document.addEventListener('trade:cart-settled', () => {
    pending = false;
    void refresh();
  });
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    pending = false;
    void refresh();
  });
  // Recheck before checkout, including Enter-key form submission.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!['cart', 'CartDrawer-Form'].includes(form.id)) return;
    const button = document.querySelector(`trade-checkout button[form="${form.id}"]`);
    if (!button) return;
    if (form.dataset.tradeVerified === 'true') {
      delete form.dataset.tradeVerified;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending || checking || failed || button.disabled) return;
    if (await refresh()) {
      form.dataset.tradeVerified = 'true';
      form.requestSubmit(button);
    }
  }, true);
  window.addEventListener('pageshow', () => { if (!pending) void refresh(); });
})();
